import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// 🔐 Centralizamos el token correctamente
const getTokenHeaders = () => {
  const token = localStorage.getItem("token") || "";
  return {
    headers: {
      "Content-Type": "application/json",
      token,
    },
  };
};

// ✅ GET: Traer todos los transportes
export const getTransportes = async () => {
  try {
    const resp = await axios.get(`${BASE_URL}/transportes`, getTokenHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener transportes",
    };
  }
};

// ✅ GET: Traer un transporte por ID
export const getTransporteById = async (id) => {
  try {
    const resp = await axios.get(`${BASE_URL}/transportes/${id}`, getTokenHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener transporte",
    };
  }
};

// ✅ POST: Crear nuevo transporte
export const postTransporte = async (transporteData) => {
  try {
    const resp = await axios.post(
      `${BASE_URL}/transportes`,
      transporteData,
      getTokenHeaders()
    );
    return resp.data;
  } catch (error) {
    console.error("❌ Error al crear transporte:", error.response?.data || error);
    return {
      ok: false,
      error: error.response?.data || "Error al crear transporte",
    };
  }
};

// ✅ PUT: Actualizar transporte
export const putTransporte = async (id, transporteData) => {
  try {
    const resp = await axios.put(
      `${BASE_URL}/transportes/${id}`,
      transporteData,
      getTokenHeaders()
    );
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar transporte",
    };
  }
};

// ✅ DELETE: Desactivar transporte
export const deleteTransporte = async (id) => {
  try {
    const resp = await axios.delete(
      `${BASE_URL}/transportes/${id}`,
      getTokenHeaders()
    );
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar transporte",
    };
  }
};
